import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { language } = useLanguage();
  
  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) setShowBanner(true);
  }, []);
  
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };
  
  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };
  
  if (!showBanner) return null;
  
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 shadow-2xl z-50 p-4 md:p-6" data-testid="cookie-banner">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1 text-center md:text-left">
          <p className="text-slate-700 text-sm md:text-base">
            {language === 'gr' 
              ? 'Ο ιστότοπος χρησιμοποιεί απαραίτητα cookies για τη σωστή λειτουργία του. Μπορείτε να αποδεχθείτε ή να διαχειριστείτε τις ρυθμίσεις σας.'
              : 'This website uses essential cookies for proper operation. You can accept or manage your settings.'}
          </p>
          <Link to="/cookies" className="text-[#F97316] text-sm hover:underline">
            {language === 'gr' ? 'Περισσότερες πληροφορίες στην Πολιτική Cookies' : 'More information in Cookie Policy'}
          </Link>
        </div>
        <div className="flex flex-wrap gap-2 justify-center">
          <button onClick={handleAccept} className="px-5 py-2 bg-[#1E3A5F] text-white rounded-lg font-medium hover:bg-[#2D5A87] transition text-sm" data-testid="accept-cookies">
            {language === 'gr' ? 'Αποδοχή' : 'Accept'}
          </button>
          <Link to="/cookies" className="px-5 py-2 bg-slate-200 text-slate-700 rounded-lg font-medium hover:bg-slate-300 transition text-sm">
            {language === 'gr' ? 'Ρυθμίσεις' : 'Settings'}
          </Link>
          <button onClick={handleReject} className="px-5 py-2 bg-slate-100 text-slate-600 rounded-lg font-medium hover:bg-slate-200 transition text-sm" data-testid="reject-cookies">
            {language === 'gr' ? 'Απόρριψη μη απαραίτητων' : 'Reject non-essential'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
